import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { Anchor, Loader2 } from "lucide-react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { api } from "@/lib/api";

const MembersOnly = ({ p, isSignedIn }) => (
  <div data-testid={`members-only-block-${p.id}`} className="mt-8 rounded-3xl border-2 border-navy bg-foam/50 p-6">
    <span className="label-chip inline-flex items-center gap-1"><Anchor className="h-3 w-3" /> Captain's Club members only</span>
    <p className="mt-3 text-sm text-slate-700">This pack is for Captain's Club members (US$50/year, renews yearly, cancel anytime online). Join to unlock it and member prices on most items.</p>
    <div className="mt-4 flex flex-wrap gap-3">
      <Link to="/captains-club" data-testid={`members-only-shop-${p.id}`} className="btn-pop bg-sunny text-navy">Join Captain's Club</Link>
      {!isSignedIn && <Link to={`/sign-in?redirect_url=${encodeURIComponent(`/shop/${p.id}`)}`} data-testid={`members-only-signin-${p.id}`} className="btn-ghost">Sign in</Link>}
    </div>
  </div>
);

const Gate = ({ p, children }) => {
  const { isLoaded, isSignedIn, getToken } = useAuth();
  const [member, setMember] = useState(null);
  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) { setMember(false); return; }
    getToken().then((t) => api.get("/account/membership", { headers: { Authorization: `Bearer ${t}` } }))
      .then(({ data }) => setMember(!!data.member)).catch(() => setMember(false));
  }, [isLoaded, isSignedIn, getToken]);
  if (member === null) return <div data-testid={`members-check-${p.id}`} className="mt-8 grid place-items-center py-6"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  return member ? children : <MembersOnly p={p} isSignedIn={isSignedIn} />;
};

// Clerk is only mounted where needed (members-only packs), keeping public pages light.
export const MembersGate = ({ p, children }) => <ClerkAuthProvider><Gate p={p}>{children}</Gate></ClerkAuthProvider>;

const TokenInner = ({ render }) => {
  const { isSignedIn, getToken } = useAuth();
  return render(async () => (isSignedIn ? getToken() : null));
};

export const WithClerkToken = ({ render }) => <ClerkAuthProvider><TokenInner render={render} /></ClerkAuthProvider>;
